export default __webpack_public_path__ + "static/img4-124ff999b55aac23ac7d526d327cfdf3.png";